import { validator } from 'lgtm';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';

// test for six alphanumeric characters (does not expect space)
export const POSTAL_CODE_VALIDATOR_CA = postalCode => /^\w{6}$/.test(postalCode);
// test for five or nine numeric characters (does not expect hyphenation)
export const POSTAL_CODE_VALIDATOR_US = postalCode => /^(?:\d{5}|\d{9})$/.test(postalCode);
export const POSTAL_CODE_VALIDATOR_GB = postalCode => /^(([a-z]{1,2}\d[\da-z]?|ascn|sthl|tdcu|bbnd|[bfs]iqq|pcrn|tkca) ?\d[a-z]{2}|bfpo ?\d{1,4}|(ky\d|msr|vg|ai)[ -]?\d{4}|[a-z]{2} ?\d{2}|ge ?cx|gir ?0a{2}|san ?ta1)$/i.test(postalCode);
export const postalCodeValidatorForCountry = country => {
  switch (country) {
    case Country.US:
      return POSTAL_CODE_VALIDATOR_US;
    case Country.CA:
      return POSTAL_CODE_VALIDATOR_CA;
    case Country.GB:
      return POSTAL_CODE_VALIDATOR_GB;
    default:
      throw new Error(`No postal code validator exists for Country (countryCode: ${country})`);
  }
};
const globalAddressValidatorGB = (country, t) => validator().validates('addressLine1').required(t('banking.checking.onboarding.address.validation.addressLine1')).validates('locality').required(t('banking.checking.onboarding.address.validation.locality')).validates('postalCode').using(postalCodeValidatorForCountry(country), t('banking.checking.onboarding.address.validation.postalCode.postal')).build();
const globalAddressValidatorUSCA = (country, t) => validator().validates('addressLine1').required(t('banking.checking.onboarding.address.validation.addressLine1')).validates('locality').required(t('banking.checking.onboarding.address.validation.locality')).validates('administrativeDistrictLevel1').required(t('banking.checking.onboarding.address.validation.administrativeDistrictLevel1')).validates('postalCode').using(postalCodeValidatorForCountry(country), country === Country.US ? t('banking.checking.onboarding.address.validation.postalCode.zip') : t('banking.checking.onboarding.address.validation.postalCode.postal')).build();
const globalAddressValidator = (country, t) => {
  switch (country) {
    case Country.US:
    case Country.CA:
      return globalAddressValidatorUSCA(country, t);
    case Country.GB:
      return globalAddressValidatorGB(country, t);
    default:
      throw new Error(`No address validator for Country (countryCode: ${country})`);
  }
};
export default globalAddressValidator;